import React from 'react';
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useRootStore} from "@stores/AppStateContext";

import {RightMenuName} from "../../../stores/RootStore";

import {RightMenuHeader as RightMenuHeaderView} from "../../components/RightMenuHeader/RightMenuHeader";

import {PAGES} from "../../../stores/ViewStore";

export const RightMenuHeader = observer(
    () => {
        const rootStore = useRootStore();
        let isRightMenuOpen = rootStore.rightMenu !== '';
        return (
            <RightMenuHeaderView
                localeKey={rootStore.currentLocale}
                title={getRightMenuHeader(rootStore.rightMenu as RightMenuName)}
                isOpen={isRightMenuOpen}
                onClose={(event) => {
                    event.stopPropagation();
                    rootStore.view.openPageByName(PAGES.DOC_EDIT, rootStore.view.pathParams, {});
                    rootStore.setRightMenu('');
                }}
            />
        )
    }
)

export const getRightMenuHeader = (currentRightMenu: RightMenuName) => {
    switch (currentRightMenu) {
        case 'outline':
            return intl.get('outline.header').d('Outline');
        case 'comments':
            return intl.get('comments.header').d('Comments');
        case 'history':
            return intl.get('history.header').d('Version History');
        case 'activeUsers':
            return intl.get('activeUsers.header').d('Active on this page');
        case 'acknowledgement':
            return intl.get('acknowledgement.header').d('Acknowledgment status');
        default:
            return '';
    }
}
